import { render, staticRenderFns } from "./orderList2.vue?vue&type=template&id=9a3ed60a&scoped=true&"
import script from "./orderList2.vue?vue&type=script&lang=js&"
export * from "./orderList2.vue?vue&type=script&lang=js&"
import style0 from "./orderList2.vue?vue&type=style&index=0&id=9a3ed60a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a3ed60a",
  null
  
)

export default component.exports